import { Button, Col, Form, Input, Modal, Row } from 'antd';
import React from 'react';

// Modal que muestra Número de cédula de identidad para reconfirmar.
const ReconfirmarCIAModal = ({
  formCedula,
  mostrarConfirmarCedula,
  onClickContinuarCedulaEditada,
  loading
}) => {
  return (
    <Modal
      title="Verificación de datos de tu cédula"
      open={mostrarConfirmarCedula}
      // onCancel={() => setMostrarConfirmarCedula(false)}
      confirmLoading={loading}
      okText="Continuar"
      // onOk={onClickContinuarCedulaEditada}
      onCancel={() => {}} // Definirlo pero sin acción
      maskClosable={false} // Evita cerrar con clic fuera
      keyboard={false} // Bloquea cierre con tecla "Esc"
      closable={false} // Elimina el botón de cerrar (X)
      footer={[
        <Button key="ok" type="primary" onClick={onClickContinuarCedulaEditada}>
          Continuar
        </Button>
      ]} // Personaliza el footer para ocultar "Cancelar"
    >
      <>
        <p>
          Para asegurarnos de que la información es correcta, ¿podrías confirmar
          si este es tu número de cédula? Puedes editarlo si es necesario.
        </p>
        <Form
          name="cedula"
          form={formCedula}
          scrollToFirstError
          layout="vertical"
        >
          <Row
            gutter={[16, 0]}
            style={{
              marginTop: 'auto',
              marginBottom: 'auto',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'start'
            }}
          >
            <Col xs={24} md={12}>
              <Form.Item
                name="numeroCedulaModificada"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </>
    </Modal>
  );
};

export default ReconfirmarCIAModal;
